<input
  type="type"
  [className]="getClassName()"
  [required]="required()"
  [disabled]="disabled"
  [placeholder]="placeholder()"
  onInput="this.style.width = (this.value.length + 1) + 'ch';"
/>
<span [className]="baseClass + '__ghost-input'">{{ value }}</span>
